import { Injectable } from '@angular/core';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';

@Injectable()
export class messagecenterService {

  constructor(private utilserv: utilityService) { }
  getPromotionalCodeService(messageComponent) {
    return this.utilserv.soapPostwithoutAction(this.getmessagelistEnvelope(messageComponent),
      AppSettings.messageCenterserviceURL);
  }
 getmessagelistEnvelope(messageComponent) {
        const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
        <s:Header>
          <a:Action s:mustUnderstand="1">http://NotificationSoapService/INotification/Notifications</a:Action>
          <a:MessageID>urn:uuid:c916c6b9-5c4a-4a00-a307-75248974e3a8</a:MessageID>
          <a:ReplyTo>
            <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
          </a:ReplyTo>
        </s:Header>
        <s:Body>
          <NotificationRequest xmlns="http://NotificationSoapService/">
          <Count>${messageComponent.messageCount}</Count>
          <Index>${messageComponent.pageIndex}</Index>
          <KeyUID>${sessionStorage.KeyUID}</KeyUID>
          <LanguageCode>${sessionStorage.langCode}</LanguageCode>
          <SessionObject xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
              <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
              <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
            </SessionObject>
          </NotificationRequest>
        </s:Body>
      </s:Envelope>`;
      return envelope;


      }

      readMessageService(msgID) {
        return this.utilserv.soapPostwithoutAction(this.readMessageEnvelope(msgID),
          AppSettings.messageCenterserviceURL);
      }
      readMessageEnvelope(msgID) {
            const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing\" xmlns:s=\"http://www.w3.org/2003/05/soap-envelope">
            <s:Header>
              <a:Action s:mustUnderstand="1">http://NotificationSoapService/INotification/NotificationRead</a:Action>
              <a:MessageID>urn:uuid:a2ea07e9-38c1-448e-9513-cbf270ac77df</a:MessageID>
              <a:ReplyTo>
                <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
              </a:ReplyTo>
            </s:Header>
            <s:Body>
              <NotificationReadRequest xmlns="http://NotificationSoapService/">
                <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                <MessageId>${msgID}</MessageId>
                <SessionObject xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                  <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
           <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                </SessionObject>
              </NotificationReadRequest>
            </s:Body>
          </s:Envelope>`;
          return envelope;


          }
          deleteMessageService(msgID) {
            return this.utilserv.soapPostwithoutAction(this.deletedMessageEnvelope(msgID),
              AppSettings.messageCenterserviceURL);
          }
          deletedMessageEnvelope(msgID) {
                const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                <s:Header>
                  <a:Action s:mustUnderstand="1">http://NotificationSoapService/INotification/NotificationDelete</a:Action>
                  <a:MessageID>urn:uuid:a2ea07e9-38c1-448e-9513-cbf270ac77df</a:MessageID>
                  <a:ReplyTo>
                    <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                  </a:ReplyTo>
                </s:Header>
                <s:Body>
                  <NotificationReadRequest xmlns="http://NotificationSoapService/">
                  <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                    <MessageId>${msgID}</MessageId>
                    <SessionObject xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                    <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                    <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                    </SessionObject>
                  </NotificationReadRequest>
                </s:Body>
              </s:Envelope>
              `;
              return envelope;
              }
}



// WEBPACK FOOTER //
// ./src/app/_services/messagecenter/messagecenterservice.ts